module.exports = __webpack_public_path__ + "static/media/calendar.df17ad19.svg";